var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{attrs:{"title":_vm.title,"wide":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('bank-details-list',{ref:"list",attrs:{"filters":_vm.query},on:{"beforeRequest":_vm.onBeforeRequest}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }